import r from "js-cookie";
import d from "./index82.mjs";
import { useEffect as y } from "react";
import { StorageKey as x } from "./index50.mjs";
import { useStorage as p } from "./index51.mjs";
import { CookiesEnum as n } from "./index49.mjs";
const a = (e) => e ? `${x.SessionStorePrefix}${e}:` : x.SessionStorePrefix, v = (e, { namespace: o, userContextKey: t } = {}) => {
  const i = t ?? r.get(n.UserContextKey), S = a(o), c = i ? d(i) : "shared";
  return `${S}${c}:${e}`;
}, C = (e) => e ? `${n.BrowserSessionActiveId}_${e}` : n.BrowserSessionActiveId, u = (e, o) => r.get(o) === e, l = (e) => {
  y(() => {
    e && r.set(n.UserContextKey, e, {
      path: "/",
      secure: !0,
      sameSite: "strict"
    });
  }, [e]);
}, E = (e, o = {}) => {
  const { namespace: t, userContextKey: i, ...S } = o, c = i ?? r.get(n.UserContextKey), m = c ?? "shared", g = a(t), f = C(t), K = v(e, { namespace: t, userContextKey: c }), s = p(K, S);
  return y(() => {
    u(m, f) || (s.removeByPrefix(g), r.set(f, m, {
      sameSite: "strict",
      path: "/"
    }));
  }, [f, s.removeByPrefix, m, g]), t ? {
    ...s,
    getItem: () => u(m, f) ? s.getItem() : null
  } : s;
};
export {
  v as getSessionStoreKey,
  l as useExtendSessionId,
  E as useSessionStore
};
